import classNames from 'classnames'
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import closeModalIcon from '../../assets/closeModal.svg'
import { BeneficiaryType } from 'types/beneficiary'
import UpdateInfo from 'containers/SettingProfileContainer/updateInfo'
import { useFormik } from 'formik'
import { LISTBANCAIRE } from 'components/listCartebancairepays'
import BeneficiaryPersonalInfo from './BeneficiaryPersonalInfo'
import { createBeneficiaryValidationSchema } from './createBeneficiaryValidationSchema'
import Avatar from 'components/avatar'

type Bank = {
  index: number
  code: string
  name: string
  swift: string
}

type CountryConfig ={
    LengthRIB?:number | { min: number; max: number }
    LengthCIN?:number
    lengthPhone:number
    lengthCodeIBAN?:number
    CodeIBAN?: string
    banks?:Bank[]

}

interface FormValues {
  avatar?: number
  firstName: string
  lastName: string
  gender: string
  relationship: string
  phonePrefix: string
  phoneNumber: string
  Iban?: string
  confirmerNumeroCompte?: string
  beneficiaryIdentifiant?: string
  bankName?: string
  CodeIBAN?: string
  SWIFTBIC?: string
  bankCode?: string
}

type BeneficiaryAction = 'delete' | 'update' | 'service' | null
interface Props {
  val: string
  setAction: Dispatch<SetStateAction<BeneficiaryAction>>
  HandleUpdate: (values:any) => void
  beneficiary: BeneficiaryType | null
  isLoading:boolean
  setSelectedBeneficiary: (val:BeneficiaryType | null)=>void
}

const ModalUpdateBeneficiary: React.FC<Props> = ({ 
  setAction, HandleUpdate, beneficiary, isLoading, setSelectedBeneficiary
 }) => {

  const [selectedCountryConfig, setSelectedCountryConfig] = useState<CountryConfig | null>(null)
  const optionsLien = [
    { index: 0, code: 'FAMILY', name: 'Famille' },
    { index: 1, code: 'FRIEND', name: 'Amis' },
    { index: 2, code: 'SELF', name: 'Moi même' },
    { index: 3, code: 'OTHER', name: 'Autres' },
  ]
   const COUNTRY_MAP: Record<string, string> = {
    '216': 'TUN',
    '221': 'SEN',
    '212': 'MAR',
    '92': 'PAK',
    '880': 'BDT',
    '90': 'TUR',
    '234': 'NGA',
    '254': 'KEN',
    '63': 'PHL',
  }
  const isTurkeyOrPhilippines =
  beneficiary?.personalInfo.phone.prefix === '90' || beneficiary?.personalInfo.phone.prefix === '63'
  const [avatar, setAvatar] = useState(beneficiary?.avatar)


  const initialValues: FormValues = {
    avatar: avatar,
    firstName: beneficiary?.personalInfo.firstName ?? '_',
    lastName: beneficiary?.personalInfo.lastName ?? '_',
    gender: beneficiary?.personalInfo.gender==='female' ? 'Femme' : 'Homme',
    relationship: optionsLien.find((item)=>item.code === beneficiary?.relationship)?.name ?? '_',
    phonePrefix: beneficiary?.personalInfo.phone.prefix ?? '216',
    phoneNumber: beneficiary?.personalInfo.phone.number ?? '',
    Iban: beneficiary?.accountNumber ?? '',
    confirmerNumeroCompte: beneficiary?.accountNumber ?? '',
    beneficiaryIdentifiant:beneficiary?.identifiantCardNumber ?? '',
    bankName:beneficiary?.bankName ?? '',
    SWIFTBIC:beneficiary?.SWIFTBIC ?? '',
    bankCode: beneficiary?.bankCode ?? '',
  }



  const handleSubmit =async () => {
    console.log('okok')
    try{
      if(formik.dirty){
        HandleUpdate(formik.values)
      }else{
        setSelectedBeneficiary(null)
        setAction(null)
      }
    }catch(error)
    {
      console.log('error')
    }
  }


  const formik = useFormik<FormValues>({
    initialValues,
    validationSchema: createBeneficiaryValidationSchema(),
    onSubmit: handleSubmit,
  })
  useEffect(()=>{
    const SelectedCountry= LISTBANCAIRE[COUNTRY_MAP[formik.values.phonePrefix]]
    setSelectedCountryConfig(SelectedCountry)
  },[])

   useEffect(()=>{
       formik.setFieldValue('avatar', avatar)
    },[avatar])

  useEffect(()=>{
    if(isTurkeyOrPhilippines) {return}
    
    const SelectedCountry= LISTBANCAIRE[COUNTRY_MAP[formik.values.phonePrefix]]
    const Code= formik.values.Iban?.substring(0,SelectedCountry.lengthCodeIBAN)
    if(SelectedCountry.banks)
    {const bank= SelectedCountry?.banks.find((item)=>item.code===Code)     
          if (bank) {
            formik.setFieldValue('bankName', bank.name, false)
            formik.setFieldValue('SWIFTBIC', bank.swift, false)
            formik.setFieldValue('bankCode', bank.code, false)
          }
          else{
            formik.setFieldValue('bankName', '', false)
            formik.setFieldValue('SWIFTBIC', '', false)
            formik.setFieldValue('bankCode', '', false)
          }
    } 

  },[formik.values.Iban, formik.errors.Iban])

console.log('formik', formik.errors)
  return (
    <div className="items-center flex fixed  z-20  inset-0  shadow-inner bg-[rgba(87,84,229,0.6)] backdrop-blur-[5px] w-full">
      <div
        className={classNames(
          ' shadow-[0px_4px_10px, rgba(0,0,0,0.25)] p-[25px] sm:p-4 rounded-2xl flex flex-col w-full  mx-[30%] xl:mx-[15%] sm:mx-[20px]  bg-white ',
        )}
      >
        <img
          src={closeModalIcon}
          width={20}
          height={20}
          onClick={() => setAction(null)}
          className=" self-end   justify-end hover:cursor-pointer xs:w-[18px] sm:mx-2 sm:mt-3"
        />
        <div className="flex flex-col items-center">
          <Avatar ifUpdate={true} avatar={avatar} setAvatar={setAvatar} />
        </div>

        <form className="w-full flex flex-col" onSubmit={formik.handleSubmit}>
          <div className="max-h-[500px] my-6 flex flex-col gap-4 overflow-y-auto scrollbar-webkit  ">
            <h3 className="h3">Informations Personnelles</h3>
            <div className=' border boreder-[#F3F4F6] rounded-[16px] p-4'>
              
              <UpdateInfo
                lengthValue={20}
                formik={formik}
                infoValue2={formik.values.firstName}
                title="Prénom"
                isUpdate={false}
                fieldName="firstName"
              />

              <UpdateInfo
                lengthValue={20}
                formik={formik}
                infoValue2={formik.values.lastName}
                title="Nom"
                isUpdate={false}
                fieldName="lastName"
              />
              <UpdateInfo
                lengthValue={20}
                formik={formik}
                infoValue2={formik.values.gender}
                title="Genre"
                isUpdate={false}
                fieldName="gender"
              />

              <UpdateInfo
                widthmsgError="w-[230px] sm:w-[150px]  lg:w-[210px]"
                widthInput="w-[230px] sm:w-[150px]  h-[48px] lg:w-[210px] "
                className="justify-between items-baseline gap-20 lg:gap-10 h-[70px]"
                formik={formik}
                infoValue1={formik.values.phonePrefix}
                infoValue2={formik.values.phoneNumber}
                title="Téléphone"
                isUpdate={true}
                fieldName="phoneNumber"
              />

              <UpdateInfo
                lengthValue={20}
                formik={formik}
                infoValue2={formik.values.relationship}
                title="Lien"
                isUpdate={false}
                fieldName="relationship"
              />
            </div>


            <h3 className="h3">Informations bancaires</h3>
            <div className=' border boreder-[#F3F4F6] rounded-[16px] p-4'>
              
            {selectedCountryConfig &&
                <BeneficiaryPersonalInfo
                  formik={formik}
                  prefixSelected={formik.values.phonePrefix}
                  detailsPays={selectedCountryConfig}
                />}
              
            </div>
          </div>
          <button className='buttonBlue w-[50%]' 
            type="submit"
            disabled={!formik.isValid}
          >
            {isLoading ?
              <svg
                className="w-6 h-6 mx-auto animate-spin text-white "
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle className="opacity-50" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C6.477 0 2 4.477 2 10h2zm2 5.291A7.971 7.971 0 014 12H2c0 2.21.896 4.209 2.344 5.656l1.656-1.365z"
                ></path>
              </svg>
             : 
             'Enregistrer'
             }
          </button>
        </form>
      </div>
    </div>
  )
}

export default ModalUpdateBeneficiary
